import { render } from "./PromotionalBadge.vue?vue&type=template&id=495cafc2&scoped=true"
import script from "./PromotionalBadge.vue?vue&type=script&lang=js"
export * from "./PromotionalBadge.vue?vue&type=script&lang=js"

import "./PromotionalBadge.vue?vue&type=style&index=0&id=495cafc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495cafc2"]])

export default __exports__